/**
 * @typedef {import('src/api/payload/egd').EgdHubViewSlug} EgdHubViewSlug
 */

/**
 * Maps featured-games tab titles to hub view slugs.
 *
 * @param {string} tabTitle - Localized pseudoRoutes tab title
 * @param {(key: string) => string} t
 * @returns {EgdHubViewSlug}
 */
export function egdHubViewFromTabTitle(tabTitle, t) {
  if (tabTitle === t("pseudoRoutes.egdGameList.progressiveJackpots.title")) {
    return "progressive-jackpots";
  }
  return "new-and-popular";
}
